module.exports = __webpack_public_path__ + "static/media/facebook.50abb947.svg";